// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transcript-item_wrapper__JMCVZ {
  width: 100%;
}
.transcript-item_wrapper__JMCVZ:hover {
    outline: 2px solid var(--primaryColor);
  }
.transcript-item_content__m6kNq {
  cursor: pointer;

  display: flex;
  gap: 10px;
  align-items: flex-start;
  justify-content: space-between;

  width: 100%;
  margin: 0;
  padding: 0;
  padding: 18px 20px;
}

.transcript-item_title__wKTzT {
  font-size: 14px;
  font-weight: 500;
  line-height: 14.63px;
  color: var(--textColor);
  text-align: left;
}

.transcript-item_startTime__FvopQ {
  flex-shrink: 0;

  padding: 2px 10px 2px 10px;
  border-width: 0;
  border-radius: 3px;

  font-size: 12px;
  font-weight: 700;
  color: #ffffff;

  background: rgba(0, 0, 0, 0.5);
}

.transcript-item_startTime__FvopQ.transcript-item_active__Iavpm {
    background: var(--primaryColor);
  }

/* Smaller screens / mobile */
.smallScreen .transcript-item_wrapper__JMCVZ:not(:last-child)::after {
    content: '';

    display: block;

    width: 100%;
    height: 1px;

    background: rgba(124, 124, 124, 1);
  }
.smallScreen .transcript-item_description__UcoOv {
    display: none;
  }

.transcript-item_highlightedText__0hoyy {
  padding: 2px;
  border-radius: 2px;
  color: var(--backgroundColor);
  background-color: var(--textColor);
}

.transcript-item_highlightedText__0hoyy.transcript-item_active__Iavpm {
    font-weight: 700;
    color: #ffffff;
    background-color: var(--primaryColor);
  }
`, "",{"version":3,"sources":["webpack://./src/components/transcript/transcript-item.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AAIb;AAHE;IACE,sCAAsC;EACxC;AAEF;EACE,eAAe;;EAEf,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,8BAA8B;;EAE9B,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;;EAEd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;;EAElB,eAAe;EACf,gBAAgB;EAChB,cAAc;;EAEd,8BAA8B;AAKhC;;AAHE;IACE,+BAA+B;EACjC;;AAGF,6BAA6B;AAE3B;IACE,WAAW;;IAEX,cAAc;;IAEd,WAAW;IACX,WAAW;;IAEX,kCAAkC;EACpC;AAEA;IACE,aAAa;EACf;;AAGF;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;AAOpC;;AALE;IACE,gBAAgB;IAChB,cAAc;IACd,qCAAqC;EACvC","sourcesContent":[".wrapper {\n  width: 100%;\n  &:hover {\n    outline: 2px solid var(--primaryColor);\n  }\n}\n.content {\n  cursor: pointer;\n\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  justify-content: space-between;\n\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  padding: 18px 20px;\n}\n\n.title {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 14.63px;\n  color: var(--textColor);\n  text-align: left;\n}\n\n.startTime {\n  flex-shrink: 0;\n\n  padding: 2px 10px 2px 10px;\n  border-width: 0;\n  border-radius: 3px;\n\n  font-size: 12px;\n  font-weight: 700;\n  color: #ffffff;\n\n  background: rgba(0, 0, 0, 0.5);\n\n  &.active {\n    background: var(--primaryColor);\n  }\n}\n\n/* Smaller screens / mobile */\n:global(.smallScreen) {\n  & .wrapper:not(:last-child)::after {\n    content: '';\n\n    display: block;\n\n    width: 100%;\n    height: 1px;\n\n    background: rgba(124, 124, 124, 1);\n  }\n\n  & .description {\n    display: none;\n  }\n}\n\n.highlightedText {\n  padding: 2px;\n  border-radius: 2px;\n  color: var(--backgroundColor);\n  background-color: var(--textColor);\n\n  &.active {\n    font-weight: 700;\n    color: #ffffff;\n    background-color: var(--primaryColor);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `transcript-item_wrapper__JMCVZ`,
	"content": `transcript-item_content__m6kNq`,
	"title": `transcript-item_title__wKTzT`,
	"startTime": `transcript-item_startTime__FvopQ`,
	"active": `transcript-item_active__Iavpm`,
	"description": `transcript-item_description__UcoOv`,
	"highlightedText": `transcript-item_highlightedText__0hoyy`
};
export default ___CSS_LOADER_EXPORT___;
